import { Progress } from 'antd';
import { ProgressSize, ProgressType } from 'antd/lib/progress/progress';
import Tooltip from 'antd/lib/tooltip';
import React, { Fragment, ReactElement, useEffect, useState } from 'react';

import classes from './ProgressTracker.module.css';

interface ProgressData {
  value: number;
}

interface ProgressTrackerProps {
  completed?: number;
  data?: ProgressData[];
  showInfo?: boolean;
  showTooltip?: boolean;
  size?: ProgressSize;
  total?: number;
  type?: ProgressType;
}

function ProgressTracker({
  completed = 0,
  data = [],
  showInfo = true,
  showTooltip = false,
  size,
  total = 100,
  type,
}: ProgressTrackerProps): ReactElement {
  const [combinedPercentage, setCombinedPercentage] = useState(0);

  useEffect(() => {
    if (data) {
      const combinedTotal = data.length ? data.reduce((a, b) => a + b.value, 0) : completed;
      const percentage = (combinedTotal / total) * 100;
      let formattedPercentage;
      if (percentage) {
        formattedPercentage = percentage % 1 === 0 ? percentage : Math.floor(percentage);
        formattedPercentage = formattedPercentage > 100 ? 100 : formattedPercentage;
      } else {
        formattedPercentage = 0;
      }

      setCombinedPercentage(Number(formattedPercentage));
    }
  }, [data, completed, total]);

  return (
    <Fragment>
      <div className={classes.flex}>
        {showTooltip ? (
          <Tooltip placement="top" title={`${combinedPercentage}% Complete`}>
            <span style={{ display: 'inline-block', width: '100%' }}>
              <Progress size={size} type={type} percent={combinedPercentage} showInfo={showInfo} />
            </span>
          </Tooltip>
        ) : (
          <Progress size={size} type={type} percent={combinedPercentage} showInfo={showInfo} />
        )}
      </div>
    </Fragment>
  );
}

export default ProgressTracker;
